import { useEffect, useRef, useState, type ReactNode } from 'react'
import { useAuthStore } from '../stores/authStore'

const YTEST_URL = import.meta.env.VITE_YTEST_URL || 'https://ytest.ai'

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { initFromToken, checkAuth } = useAuthStore()
  const [authState, setAuthState] = useState<'checking' | 'authenticated' | 'unauthenticated'>('checking')
  const initRef = useRef(false)

  useEffect(() => {
    if (initRef.current) return
    initRef.current = true

    const init = async () => {
      const hadTokenInUrl = initFromToken()
      await checkAuth()

      const authenticated = useAuthStore.getState().isAuthenticated
      if (authenticated) {
        setAuthState('authenticated')
      } else {
        if (hadTokenInUrl) {
          const url = new URL(window.location.href)
          url.searchParams.delete('token')
          window.history.replaceState({}, '', url.toString())
        }
        setAuthState('unauthenticated')
      }
    }

    init()
  }, [initFromToken, checkAuth])

  if (authState === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-foreground/[0.04]">
        <div className="w-8 h-8 border-4 border-accent border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  if (authState === 'unauthenticated') {
    const returnUrl = encodeURIComponent(window.location.href)
    window.location.href = `${YTEST_URL}/login?return_to=${returnUrl}`
    return null
  }

  return <>{children}</>
}
